export default "__VITE_ASSET__BYY6GEoE__"